import { TaggedSearchState } from "./TaggedSearchReducer/Types"

export const encodeState = (state: TaggedSearchState): string =>
  encodeURI(btoa(JSON.stringify(state)));

export const decodeState = (stateString: string): TaggedSearchState =>
  JSON.parse(atob(decodeURI(stateString)));